import React, { useState } from 'react';
import { Field } from 'react-final-form';
import { SingleDatePicker, isInclusivelyBeforeDay } from 'react-dates';
import css from './SignupForm.module.css';
import { showErrorToast } from '../../../util/toast';
import { MINIMUM_AGE, validateAge } from '../../../util/validators';
import moment from 'moment';

const DateOfBirthField = ({ name, label, validate, placeholder }) => {
  const [focused, setFocused] = useState(false);

  const handleDateChange = (input, date) => {
    if (!date) {
      input.onChange(null);
      return;
    }

    const dateObj = date.toDate();

    if (validateAge(dateObj)) {
      input.onChange(dateObj);
    } else {
      showErrorToast(`You must be at least ${MINIMUM_AGE} years old.`);
    }
  };

  return (
    <Field name={name} validate={validate}>
      {({ input, meta }) => (
        <div className={css.dateOfBirthField}>
          <label htmlFor={name}>{label}</label>
          <SingleDatePicker
            date={input.value ? moment(input.value) : null}
            onDateChange={date => handleDateChange(input, date)}
            focused={focused}
            onFocusChange={({ focused: isFocused }) => setFocused(isFocused)}
            id={name}
            placeholder={'MM/DD/YYYY'}
            isOutsideRange={day => !isInclusivelyBeforeDay(day, moment())}
            displayFormat="MM/DD/YYYY"
            showClearDate
            noBorder
            readOnly={false}
            numberOfMonths={1}
          />
          {meta.error && meta.touched && <p className={css.error}>{meta.error}</p>}
        </div>
      )}
    </Field>
  );
};

export default DateOfBirthField;
